import { STREAM_PLANNED_PATH_COLOR } from "lib/consts/streamPathOverlay";
import { VideoPixelPoint } from "lib/navigation/projectPlannedPathToVideo";
import {
    computeVideoObjectFitLayout,
    videoPixelToCanvas,
} from "lib/utils/videoObjectFitLayout";

export type DrawPlannedPathOptions = {
    fitScreen: boolean;
    color?: string;
    lineWidth?: number;
    opacity?: number;
};

/**
 * Draw projected Nav2 path segments on a canvas aligned with the video element.
 * Null entries break the polyline (e.g. points behind the camera).
 */
export function drawPlannedPathOnCanvas(
    ctx: CanvasRenderingContext2D,
    canvasWidth: number,
    canvasHeight: number,
    videoWidth: number,
    videoHeight: number,
    projectedPixels: (VideoPixelPoint | null)[],
    options: DrawPlannedPathOptions,
): void {
    if (projectedPixels.length < 2) {
        return;
    }

    const layout = computeVideoObjectFitLayout(
        canvasWidth,
        canvasHeight,
        videoWidth,
        videoHeight,
        options.fitScreen,
    );
    if (!layout) {
        return;
    }

    const {
        color = STREAM_PLANNED_PATH_COLOR,
        lineWidth = 3,
        opacity = 0.9,
    } = options;

    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.globalAlpha = opacity;
    ctx.lineJoin = "round";
    ctx.lineCap = "round";

    let drawing = false;

    for (const pixel of projectedPixels) {
        if (!pixel) {
            if (drawing) {
                ctx.stroke();
                drawing = false;
            }
            continue;
        }

        const canvasPoint = videoPixelToCanvas(pixel.x, pixel.y, layout);
        if (!drawing) {
            ctx.beginPath();
            ctx.moveTo(canvasPoint.x, canvasPoint.y);
            drawing = true;
        } else {
            ctx.lineTo(canvasPoint.x, canvasPoint.y);
        }
    }

    if (drawing) {
        ctx.stroke();
    }

    ctx.restore();
}
